import { generateItems } from 'domain/common';
import { Surface } from 'domain/lib';

const { actions, selectors, reducer } = generateItems('Surface', Surface);

export { actions, selectors, reducer };
